export default __webpack_public_path__ + "static/media/card4.f8346b0e.svg";